import request from '../api';

// 添加策划
export function addPlanJob(data) {
  return request.post('/app/planJob/addPlanJob', data);
}

// 获取App策划任务分页列表
export function getAppPlanJobPage(data) {
  return request.post('/app/planJob/getAppPlanJobPage', data);
}

// 获取团队用户
export function teamGetTeamUser(data) {
  return request.post('/app/team/getTeamUser', data);
}

// App字典数据列表
export function sysDictGetAppSysDictList(data) {
  return request.post('/app/sysDict/getAppSysDictList', data);
}

// 获取App策划任务详情
export function planJobGetAppPlanJob(id) {
  return request.post(`/app/planJob/getAppPlanJob/${id}`);
}

// 立即执行
export function planJobExecuteId(id) {
  return request.get(`/app/planJob/execute/${id}`);
}

// 获取策划生成结果明细
export function planGeneratedDetailGetAppPlanGeneratedDetail(data) {
  return request.post('/app/planGeneratedDetail/getAppPlanGeneratedDetail', data);
}

// 获取策划生成结果
export function planGeneratedGetAppPlanGenerated(data) {
  return request.post('/app/planGenerated/getAppPlanGenerated', data);
}

// 修改策划
export function planJobUpdatePlanJob(data) {
  return request.post('/app/planJob/updatePlanJob', data);
}

// 修改文案内容
export function planGeneratedDetailUpdate(data) {
  return request.post('/app/planGeneratedDetail/update', data);
}

// 生成视频
export function planGeneratedDetailCreate(data) {
  return request.post('/app/planGeneratedDetail/create', data);
}

// 删除策划任务
export function planJobRemove(id) {
  return request.post(`/app/planJob/remove/${id}`);
}

// 发布前检查视频能不能发布
export function planGeneratedDetailBeforeRelease(data) {
  return request.post('/app/planGeneratedDetail/beforeRelease', data);
}

// 修改任务状态
export function planJobStatus(id) {
  return request.get(`/app/planJob/status/${id}`);
}

// 用户添加策划
export function addPlan(data) {
  return request.post('/app/plan/addPlan', data);
}

// 获取App策划分页列表
export function getAppPlanPage(data) {
  return request.post('/app/plan/getAppPlanPage', data);
}

// 用户修改策划
export function updatePlan(data) {
  return request.post('/app/plan/updatePlan', data);
}

// 获取App策划详情
export function getAppPlan(id) {
  return request.post(`/app/plan/getAppPlan/${id}`);
}

// 用户删除策划
export function deletePlan(id) {
  return request.post(`/app/plan/deletePlan/${id}`);
}

// 转换状态
export const PLAN_STATUS = {
  FATHER: {
    DRAFT: 0, // 0 草稿
    EXTRACTING: 1, // 1 制作中
    GENERATING: 2, // 2 部分完成
    GENERATED: 3, // 3 完成
    FAILED: 4, // 4 失败
  },
  CHILD: {
    DRAFT: 0, // 0 草稿
    EXTRACTING: 1, // 1 生成中
    GENERATING: 2, // 2 生成成功
    GENERATED: 3, // 3 生成失败
    PUBLISH: 4, // 4 已发布
  },
};
